import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "./auth.service";
import { MatDialog } from "@angular/material/dialog";
import { LoginDialogComponent } from "../components/dialogs/login-dialog/login-dialog.component";
import { AuthUtilitiesService } from "./auth-utilities.service";
import { NgxPermissionsService } from "ngx-permissions";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(private authService: AuthService) {}
  #loginService = inject(AuthUtilitiesService);
  #permissionsService = inject(NgxPermissionsService);
  #toastService = inject(ToastService);
  #router = inject(Router);
  #translate = inject(TranslateService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authService.currentUserValue;
    if (!currentUser) {
      this.#toastService.toastError(
        this.#translate.instant("AUTH.UNAUTHORIZED_ALERT")
      );
      this.#loginService.openLoginDialog();
      // logged in so return true
      return false;
    }

    const targetRoute = this.getDeepestRoute(route);
    const { roles, permissions } = targetRoute.data;

    // check role
    if (roles && !roles.includes(currentUser.role.id)) {
      return this.#router.createUrlTree(["/403"]);
    }

    // check permission
    if (permissions) {
      return this.#permissionsService
        .hasPermission(permissions)
        .then((ok) => ok || this.#router.createUrlTree(["/403"]));
    }

    return true;
  }

  private getDeepestRoute(
    route: ActivatedRouteSnapshot
  ): ActivatedRouteSnapshot {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
